"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZSwitch = void 0;
const kendo_react_labels_1 = require("@progress/kendo-react-labels");
const kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
const LocalizedComponent_1 = require("../../languages/LocalizedComponent");
const useLanguage_1 = require("../../languages/useLanguage");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SwitchWrapper = styled_components_1.default.div `
   display: inline-flex;
   margin-right: 15px;

   .k-label {
      margin-left: 5px;
      font-size: 12px;
   }

   .k-switch {
      .k-switch-label-on,
      .k-switch-label-off {
         font-size: 7px;
      }

      .k-switch-label-on {
         left: 6px;
      }

      .k-switch-label-off {
         right: 6px;
      }

      .k-switch-label-on {
         top: 10px;
      }

      .k-switch-label-off {
         top: 11px;
      }

      .k-switch-handle::before {
         height: 100%;
         width: 100%;
      }
   }

   .k-switch-on.k-state-disabled .k-switch-label-on {
      color: white !important;
   }

   .k-switch-on .k-switch-handle {
      left: calc(100% - 18px);
   }

   .k-switch-off .k-switch-handle {
      left: 3px;
   }
`;
exports.ZSwitch = (props) => {
    const languageId = useLanguage_1.useLanguage();
    const { label, onLabel, offLabel, value, defaultValue, disabled, readOnly, onChange } = LocalizedComponent_1.getLocalizedProps({
        ...props,
        onLabel: props.onLabel || "ON",
        offLabel: props.offLabel || "OFF"
    }, languageId, ["label", "onLabel", "offLabel"], props.localize);
    return (react_1.default.createElement(SwitchWrapper, null,
        react_1.default.createElement(kendo_react_inputs_1.Switch, { onLabel: onLabel, offLabel: offLabel, checked: value, defaultChecked: defaultValue, disabled: disabled || readOnly, onChange: onChange }),
        react_1.default.createElement(kendo_react_labels_1.Label, null, label)));
};
//# sourceMappingURL=ZSwitch.js.map